<template>
  <div>
    <div id="certificate-container">
      <div
        style="
          display: flex;
          justify-content: space-between;
          height: calc(100vh - 175px);
          border-top: 1px solid rgba(0, 0, 0, 0.08);
        "
      >
        <!-- Sidebar with draggable items -->
        <div
          style="
            width: 20%;
            border-right: 1px solid rgba(0, 0, 0, 0.08);
            padding: 1em 1em 0 0;
            overflow-y: auto;
          "
        >
          <div id="sidebar">
            <v-form>
              <template>
                <div>
                  <vue-dropzone
                    id="dropzone"
                    :awss3="awss3"
                    ref="myVueDropzone"
                    duplicateCheck
                    :options="dropzoneOptions"
                    @vdropzone-s3-upload-error="s3UploadError"
                    @vdropzone-s3-upload-success="s3UploadSuccess"
                    @vdropzone-file-added="handleImageChange"
                    @vdropzone-max-files-exceeded="maxFiles"
                    @vdropzone-removed-file="removeImage"
                  ></vue-dropzone>
                  <p
                    class="block text-left mt-4 caption"
                    style="color: #2c3e50"
                  >
                    Accepted file formats: jpeg, jpg, png
                  </p>
                </div>
              </template>
            </v-form>
            <h2 class="mt-5">Elements</h2>
            <div>
              <div
                v-for="(item, index) in sidebarItems"
                :key="index"
                class="sidebar-item"
                :draggable="!item.disabled"
                @dragstart="startDrag(item)"
                :style="{
                  border: '1px solid rgba(0, 0, 0, 0.08)',
                  padding: '10px',
                  width: '160px',
                  cursor: item.disabled ? 'not-allowed' : 'grab',
                  backgroundColor: item.disabled
                    ? 'rgba(0, 0, 0, 0.06)'
                    : '#fff',
                  margin: '10px 0',
                  color: '#000',
                }"
              >
                {{ item.name }}
                <span v-if="item.disabled">(Used)</span>
              </div>
              <v-btn
              v-if="tutorialBtnloading"
              outlined
              class="btn btn-primary add-course-button"
              color="primary"
              loading
            ></v-btn>
              <v-btn
              v-else
              class="btn btn-primary add-course-button"
              color="primary"
              @click="goToResources(resourceId)"
              outlined
              >VIEW TUTORIAL</v-btn
            >    
            </div>
          </div>
        </div>

        <!-- Main draggable area -->
        <div
          style="
            width: 60%;
            display: flex;
            align-items: center;
            justify-content: space-evenly;
            flex-direction: column;
            gap: 1em;
            overflow-x: hidden;
          "
          class="certificate-parent"
        >
          <div
            id="certificate"
            :style="{
              display: 'inline-block',
              position: 'relative',
              backgroundImage: `url(${previewImage})`,
              width: imageWidth + 'px' /* Set width dynamically */,
              height: imageHeight + 'px' /* Set height dynamically */,
              backgroundSize: 'contain',
              backgroundRepeat: 'no-repeat',
              backgroundPosition: 'center',
              aspectRatio: 'auto 1 / 1',
            }"
            @dragover.prevent
            @drop="onDrop"
          >
            <vue-draggable-resizable
              v-for="(droppedItem, index) in droppedItems"
              :id="'draggable-' + index"
              :key="index"
              :x="droppedItem.x"
              :y="droppedItem.y"  
              :w="'auto'"
              :h="'auto'"
              :parent="true"            
              style="
                min-width: 140px;
                border: 1px dashed rgba(0, 0, 0, 0.4);
                position: absolute;
                border-radius: 5px;
                text-align: center;
              "
              @dragging="updatePosition(index)"
            >
              <div
                style="padding: 3px 10px; text-align: justify; cursor: grab"
                @click.stop="handleItem(droppedItem, index)"
              >
                <span
                  v-if="droppedItem.name === 'Text Box'"
                  :style="{
                    fontFamily: droppedItem.property.font.value,
                    fontSize: droppedItem.property.fontSize.value,
                    fontWeight: droppedItem.property.fontWeight.value,
                    color: droppedItem.property.color,
                  }"
                >
                <div style="
                    display: inline-block;
                    text-align: center;
                    white-space: normal;
                    position: relative;
                    left: 50%;
                    transform: translateX(-50%);
                    box-sizing: content-box;"
                  >
                  {{ droppedItem.property.value }}
                  </div>  
                </span>

                <span
                  v-else
                  :id="droppedItem.name"
                  :style="{
                    fontFamily: droppedItem.property.font.value,
                    fontSize: droppedItem.property.fontSize.value,
                    fontWeight: droppedItem.property.fontWeight.value,
                    color: droppedItem.property.color,
                  }"
                >
                <div style="
                    display: inline-block;
                    text-align: center;
                    white-space: normal;
                    max-width: 200px;
                    position: relative;
                    left: 50%;
                    transform: translateX(-50%);
                    box-sizing: content-box;"
                  >
                    {{ droppedItem.name }}
                  </div>
                </span>
              </div>
            </vue-draggable-resizable>
          </div>
          <div style="display: inline-flex;">
            <v-btn
              v-if="loading"
              style="display: flex; margin: 0 auto"
              outlined
              class="btn btn-primary add-course-button text-right"
              color="primary"
              loading
            ></v-btn>
            <v-btn
              v-else
              style="display: flex; margin: 0 auto"
              class="btn btn-primary add-course-button text-right"
              color="primary"
              @click="processQueue"
              outlined
              >Save</v-btn
            >            
            <v-btn
              v-if="previewLoading"
              style="display: flex; margin: 0 auto"
              outlined
              class="btn btn-primary add-course-button text-right ml-5"
              color="primary"
              loading
            ></v-btn>
            <v-btn v-if="!previewLoading && previewEnabled"
              style="display: flex; margin: 0 auto"
              class="btn btn-default add-course-button text-right ml-5"
              color="primary"
              @click="previewCertificate"
              outlined
            >Preview</v-btn>
          </div>
        </div>

        <!-- Sidebar with draggable items -->
        <div
          style="
            width: 20%;
            border-left: 1px solid rgba(0, 0, 0, 0.08);
            padding: 1em 0 0 1em;
            overflow-y: auto;
          "
        >
          <div
            id="element-sidebar"
            v-if="selectedItem && selectedItemIndex !== null"
          >
            <h3>Selected {{ selectedItem.name }}</h3>
            <v-form>
              <v-text-field
                v-if="selectedItem.name === 'Text Box'"
                label="Text"
                v-model="selectedItem.property.value"
                filled
              ></v-text-field>
              <v-combobox
                v-model="selectedItem.property.font"
                :items="topHtmlFonts"
                item-text="name"
                item-value="value"
                label="Select Font"
                filled
              ></v-combobox>
              <v-combobox
                :items="htmlFontSize"
                v-model="selectedItem.property.fontSize"
                item-text="name"
                item-value="value"
                label="Select Font Size"
                filled
              ></v-combobox>

              <v-combobox
                v-model="selectedItem.property.fontWeight"
                :items="filteredFontWeights"
                item-text="name"
                item-value="value"
                label="Select Font Weight"
                filled
              ></v-combobox>

              <v-color-picker
                v-model="selectedItem.property.color"
                label="Color"
                filled
              ></v-color-picker>
              <v-btn
                class="delete-item-button"
                @click="removeItem(selectedItemIndex)"
                style="margin-left: 10px"
              >
                Remove Item
              </v-btn>
            </v-form>
          </div>
          <div v-else>
            <h3>Selected Item</h3>
            <p>Select an item to edit</p>
          </div>
        </div>
      </div>
    </div>
    <div id="nosupport">
      <h1>Sorry, your screen size is to small to use certificate editor</h1>
    </div>
  </div>
</template>
<script>
import companyAPI from '@/api/company.js';
import vue2Dropzone from 'vue2-dropzone';
import { IMPROVE_CONFIG } from '@/config.js';
import userAPI from '@/api/user.js';
export default {
  name: 'NewCertificate',
  components: {
    vueDropzone: vue2Dropzone,
  },
  data() {
    return {
      sidebarItems: [
        {
          name: 'Course Name',
          property: {
            font: {
              name: 'Arial',
              value: 'Arial, sans-serif',
            },
            fontSize: {
              name: 'Small',
              value: '12px',
            },
            fontWeight: {
              name: 'Normal',
              value: '400',
            },
            color: '#000000',
          },
          disabled: false,
        },
        {
          name: 'User Name',
          property: {
            font: {
              name: 'Arial',
              value: 'Arial, sans-serif',
            },
            fontSize: {
              name: 'Normal (Default)',
              value: '16px',
            },
            fontWeight: {
              name: 'Normal',
              value: '400',
            },
            color: '#000000',
          },
          disabled: false,
        },
        {
          name: 'Completed Date',
          property: {
            font: {
              name: 'Arial',
              value: 'Arial, sans-serif',
            },
            fontSize: {
              name: 'Small',
              value: '12px',
            },
            fontWeight: {
              name: 'Normal',
              value: '400',
            },
            color: '#000000',
          },
          disabled: false,
        },
        {
          name: 'Text Box',
          property: {
            font: {
              name: 'Arial',
              value: 'Arial, sans-serif',
            },
            fontSize: {
              name: 'Normal (Default)',
              value: '16px',
            },
            fontWeight: {
              name: 'Normal',
              value: '400',
            },
            color: '#000000',
            value: 'Enter Text',
          },
          disabled: false,
        },
      ],
      draggedItem: null,
      droppedItems: [],
      imageWidth: 561, // Set the width of the image
      imageHeight: 396, // Set the height of the image
      selectedItem: null,
      selectedItemIndex: null,
      messages: {},
      errorMessage:
        'Oops, something went wrong! Please check information is correct.',
      certificateSuccessMessage: 'Certificate Successfully Updated.',
      waitMessage: 'Please wait, we are uploading certificate.',
      type: 'company_certificate_templates',
      accepted: 'image/jpg,image/jpeg,image/png',
      loading: false,
      certificateData: [],
      previewImage: null,
      name: '',
      topHtmlFonts: [
        { name: 'Arial', value: 'Arial, sans-serif' },
        { name: 'Helvetica', value: 'Helvetica, sans-serif' },
        { name: 'Times New Roman', value: 'Times New Roman, serif' },
        { name: 'Georgia', value: 'Georgia, serif' },
        { name: 'Verdana', value: 'Verdana, sans-serif' },
        { name: 'Courier New', value: 'Courier New, monospace' },
        { name: 'Tahoma', value: 'Tahoma, sans-serif' },
        { name: 'Trebuchet MS', value: 'Trebuchet MS, sans-serif' },
        { name: 'Lucida Sans', value: 'Lucida Sans, sans-serif' },
        { name: 'Roboto', value: 'Roboto, sans-serif' },
        { name: 'Sora', value: 'Sora, sans-serif'}
      ],
      htmlFontSize: [
        { name: 'Very Small', value: '8px' },
        { name: 'Small', value: '12px' },
        { name: 'Normal (Default)', value: '15px' },
        { name: 'Large', value: '18px' },
        { name: 'Larger', value: '20px' },
      ],
      htmlFontWeight: [
        { name: 'Light', value: '300' },
        { name: 'Normal', value: '400' },
        { name: 'Medium', value: '500' },
        { name: 'Semi-Bold', value: '600' },
        { name: 'Bold', value: '700' },
      ],
      dropzoneOptions: {
        url: `${IMPROVE_CONFIG.API_URL}/nowhere`,
        uploadMultiple: false,
        addRemoveLinks: true,
        capture: true,
        params: {},
        maxFiles: 1,
        timeout: 9999999999,
        dictDefaultMessage: 'Upload Certificate',
        maxFilesize: this.maxFilesize,
        acceptedFiles: 'image/jpg,image/jpeg,image/png',
        autoProcessQueue: false,
      },
      awss3: {
        signingURL: IMPROVE_CONFIG.API_URL + '/sign',
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('token'),
          Accept: 'application/json',
          'Access-Control-Allow-Origin': '*',
        },
        params: {
          type: 'thumbnail',
        },
        sendFileToServer: false,
        withCredentials: false,
        fileDetails: {},
        width: 118
      },
      finishedcertificate: '',
      previewLoading: false,
      previewEnabled: false,
      tutorialBtnloading: false,
      resourceId: '',
    };
  },
  watch: {
  'selectedItem.property.font.name': {
    immediate: true,
    handler() {
      const allowedWeights = this.filteredFontWeights.map(w => w.value)
      const currentWeight = this.selectedItem.property.font.weight
      // Reset if current weight is not allowed for selected font
      if (!allowedWeights.includes(currentWeight)) {
        this.selectedItem.property.fontWeight = 'Normal'
      }
    }
  }
  },
  computed: {
    s3Uploading() {
      return this.$store.getters.s3Uploading;
    },
    maxUploadSize() {
      return 10;
    },
    filteredFontWeights() {
    if (!this.selectedItem.property.font.name) return []

    // Normalize font name check
    const font = this.selectedItem.property.font.name.toLowerCase()

    // Fonts that support all weights
    const variableFonts = ['roboto', 'sora']

    const isVariableFont = variableFonts.some(f =>
      font.includes(f)
    )

    // If Roboto or Sora → return all weights
    if (isVariableFont) {
      return this.htmlFontWeight
    }

    // Fonts that support normal weights
    const onlyNormalFonts = ['courier new', 'lucida sans']

    const isOnlyNormalFonts = onlyNormalFonts.some(f =>
      font.includes(f)
    )

    // If courier new or lucida sans → return normal weights
    if (isOnlyNormalFonts) {
      return this.htmlFontWeight.filter(weight =>
          ['400'].includes(weight.value)
      )
    }

    // Otherwise → only Normal & Bold
    return this.htmlFontWeight.filter(weight =>
      ['400', '700'].includes(weight.value)
    )
  }

  },
  mounted() {
    this.getCertificate();
    this.getAllResourceCategories();
  },
  methods: {
    maxFiles(file) {
      this.$refs.myVueDropzone.removeFile(file);
    },
    dropzoneError(file, msg) {
      this.$snotify.error(msg);
      this.$refs.myVueDropzone.removeFile(file);
    },
    getCertificate() {
      this.loading = true;
      this.$store.dispatch('setDropzoneLoaded', { id: 'certificate', value: true });

      companyAPI.getCertificate().then((resp) => {
        this.loading = false;
        this.certificateData = resp.data.data;

        if (Object.keys(this.certificateData).length > 0) {
          // clear the dropzone
          this.$refs.myVueDropzone.removeAllFiles();

          // Load certificate on DropZone
          this.$refs.myVueDropzone.manuallyAddFile(
            {
              size: this.certificateData.file_size,
              name: this.certificateData.original_name,
              type: this.certificateData.mime_type,
            },
            this.certificateData.url
          );

          // Load certificate on previewImage
          setTimeout(() => {
            this.previewImage = this.certificateData.url;
            this.droppedItems = this.certificateData.styles;
            this.disableSidebarItems();
          }, 2000);

          // Set Certificate S3 URL
          this.$store.dispatch('setS3Url', this.certificateData.url);

          // Set Certificate File Details
          this.$store.dispatch('setFileDetails', {
            size: this.certificateData.file_size,
            name: this.certificateData.original_name,
            type: this.certificateData.mime_type,
          });

          this.$store.dispatch('setDropzoneLoaded', { id: 'certificate', value: false });
          this.$store.dispatch('setS3Uploading', false);
          this.previewEnabled = true
        } else {
          this.$store.dispatch('setFileDetails', {});
        }
      });
    },
    processQueue() {
      this.finishedcertificate = this.removeBorderStyle(document.getElementById('certificate').outerHTML)
      // Check if certificate has loaded
      if(this.previewImage === null && Object.keys(this.$store.getters.fileDetails).length > 0){
        this.previewLoading = false;
        this.$snotify.error('Certificate not found please wait for certificate to load');
        return;
      }

      if (Object.keys(this.$store.getters.fileDetails).length > 0) {
        this.$snotify.info(this.waitMessage);
        this.loading = true;
        this.$refs.myVueDropzone.processQueue(); // Start Uploading Certificate on S3
      }
      this.AddUpdateCertificate();  
    },
    removeBorderStyle(inputString) {
      // First, update the translate values
      const newString = this.updateTranslateValues(inputString);
      // Then, remove the specific border style and dimensions
      return newString
        .replace(/border: 1px dashed rgba\(0, 0, 0, 0.4\);/g, '') // Removes the border style
        .replace(/width: 561px; height: 396px;/g, 'width: 1122px; height: 792px;') // Updates the width and height
        .replace(/font-size: ([\d.]+)px;/g, (match, fontSize) => {
          // Double the font size
          const newFontSize = parseFloat(fontSize) * 2;
          return `font-size: ${newFontSize}px;`;
        });
    },
    updateTranslateValues(inputString) {
      return inputString.replace(/translate\(([\d.]+)px, ([\d.]+)px\)/g, (match, x, y) => {
        // Parse x and y values
        const parsedX = parseFloat(x);
        const parsedY = parseFloat(y);

        // Find the item within a 1-2 pixel range
        const item = this.droppedItems.find(
          (item) =>
            Math.abs(item.x - parsedX) <= 3 && Math.abs(item.y - parsedY) <= 3
        );
        
        // Check if item exists before accessing its properties
        if (item && item.name === "Text Box") {
          // get width and height of the element
          const element = document.getElementById('draggable-' + this.droppedItems.indexOf(item));

          // get width and height of the element
          const width = element.offsetWidth;
          const height = element.offsetHeight;

          // If width is less than 140, center the element
          if (width <= 140) {
            const newX = Math.round(parsedX + (width / 2));
            const newY = Math.round(parsedY + (height / 2));
            return `translate(${Math.round(newX * 2)}px, ${Math.round(newY * 2)}px) translate(-50%, -50%)`;
          }

          // Add offset to parsedX
          const newX = Math.round(parsedX * 2);
          const newY = Math.round(parsedY * 2);

          return `translate(${Math.round(newX)}px, ${Math.round(newY)}px)`;
        }

        // Add offset to parsedX
        const newX = Math.round(parsedX + 69);
        const newY = Math.round(parsedY + 22);
        return `translate(${Math.round(newX * 2)}px, ${Math.round(newY * 2)}px) translate(-50%, -50%)`;
      });
    },
    AddUpdateCertificate() {
      this.loading = true;
      companyAPI
        .addUpdateCertificate(
          this.$store.getters.s3Url,
          this.$store.getters.fileDetails,
          this.finishedcertificate,
          this.droppedItems
        )
        .then(() => {
          this.loading = false;
          this.$snotify.success(this.certificateSuccessMessage);
          setTimeout(() => {
            this.$gf.removeBackdrop();
          }, 300);
        })
        .catch((err) => {
          this.valid = false;
          this.messages = this.$gf.errorResponse(err);
          this.$snotify.error(this.errorMessage);
          this.loading = false;
          setTimeout(() => {
            this.$gf.removeBackdrop();
          }, 300);
        });
    },
    handleImageChange(event) {
      const file = event;

      if (file instanceof Blob) {
        this.disabledButton = false;
        this.$store.dispatch('setS3Uploading', true);
        let fileDetails = {
          size: file.size,
          name: file.name,
          type: file.type,
        };
        this.$store.dispatch('setFileDetails', fileDetails);

        const reader = new FileReader();

        reader.onload = (e) => {
          this.previewImage = e.target.result;
          this.calculateImageDimensions().then((correctSize) => {
            if (!correctSize) {
              this.$refs.myVueDropzone.removeFile(file);
              this.removeImage();
              return;
            }

            if (this.droppedItems.length === 0) {
              setTimeout(() => {
                this.defaultDraggableItems();
              }, 300);
            }
          });
        };

        reader.readAsDataURL(file);
        this.previewEnabled = true;
      }
    },
    calculateImageDimensions() {
      return new Promise((resolve) => {
        const img = new Image();
        img.src = this.previewImage;

        img.onload = () => {
          if (img.width < 561 || img.height < 396) {
            this.$snotify.error('Image dimensions must be at least 561x396 pixels.');
            resolve(false);
          } else if (img.width < 1122 || img.height < 792) {
            this.$snotify.warning('Image may be stretched. It is recommended to use 1122x792 pixels.');
          }
          resolve(true);
        };
      });
    },
    removeImage() {
      // UPDATED
      document.getElementById('dropzone').className += ' enableMax';
      this.$store.dispatch('clearFile');
      this.$store.dispatch('setFileDetails', {});
      this.previewImage = null;
      this.droppedItems = [];
      this.draggedItem = null;
      this.selectedItem = null;
      this.selectedItemIndex = null;
      this.resetSidebarItems();
      this.previewEnabled = false;
    },
    s3UploadSuccess(s3ObjectLocation) {
      let url = decodeURIComponent(s3ObjectLocation);
      this.$store.dispatch('setS3Url', url);
      this.$store.dispatch('setS3Uploading', false);

      this.AddUpdateCertificate();
    },
    s3UploadError(errorMessage) {
      this.$snotify.error(errorMessage);
      this.uploading = false;
    },
    startDrag(item) {
      const deepCopy = JSON.parse(JSON.stringify(item));
      
      if (!this.previewImage) {
        this.$snotify.error('Please upload certificate first');
        return;
      }

      if (!item.disabled) {
        this.draggedItem = deepCopy;
      }
    },
    disableSidebarItems(item) {
      this.sidebarItems = this.sidebarItems.map((item) => {
        const found = this.droppedItems.find(
          (droppedItem) => droppedItem.name === item.name
        );
        if (found) {
          if(item.name === 'Text Box') return { ...item, disabled: false };
          return { ...item, disabled: true };
        }
        return item;
      });
    },
    resetSidebarItems() {
      this.sidebarItems = this.sidebarItems.map((item) => {
        return { ...item, disabled: false };
      });
    },
    defaultDraggableItems() {
      // use imageWidth and imageHeight to calculate the x and y values in the middle vertically and spaced horizontally
      const x = this.imageWidth / 2;
      const y = this.imageHeight / 2;

      this.droppedItems = [
        {
          name: 'User Name',
          property: {
            font: { name: 'Arial', value: 'Arial, sans-serif' },
            fontSize: { name: 'Normal (Default)', value: '16px' },
            fontWeight: { name: 'Normal', value: '400' },
            color: '#000000',
          },
          disabled: true,
          x: x - 75,
          y,
        },
        {
          name: 'Course Name',
          property: {
            font: { name: 'Arial', value: 'Arial, sans-serif' },
            fontSize: { name: 'Small', value: '12px' },
            fontWeight: { name: 'Normal', value: '400' },
            color: '#000000',
          },
          disabled: true,
          x: x - 75,
          y: y - 50,
        },
        {
          name: 'Completed Date',
          property: {
            font: { name: 'Arial', value: 'Arial, sans-serif' },
            fontSize: { name: 'Small', value: '12px' },
            fontWeight: { name: 'Normal', value: '400' },
            color: '#000000',
          },
          disabled: true,
          x: x - 75,
          y: y + 50,
        },
      ];

      this.disableSidebarItems();
    },
    updatePosition(index) {
      const itemToUpdate = document.getElementById('draggable-' + index);

      if (itemToUpdate) {
        // get inline style of the element
        const style = itemToUpdate.getAttribute('style');
        // get translate values from the style
        const translateValues = style
          .match(/translate\(([^)]+)\)/)[1]
          .split(',');
          
        // get x and y values
        const x = parseFloat(translateValues[0].replace('px', ''));
        const y = parseFloat(translateValues[1].replace('px', ''));

        // update the x and y values in the droppedItems array
        this.droppedItems[index].x = x;
        this.droppedItems[index].y = y;
      }
    },
    onDrop(event) {
      if (this.draggedItem) {
        const x = event.offsetX;
        const y = event.offsetY;
        // Check if the item has already been dropped
        if (!this.draggedItem.disabled) {
          this.droppedItems.push({ ...this.draggedItem, disabled: true, x, y });

          // Disable the item in the sidebar
          if (this.draggedItem.name === 'Text Box') {
            this.draggedItem.disabled = false; // Disable in sidebar
          }
        }
        this.draggedItem = null;
        this.disableSidebarItems();
      }
    },
    removeItem(index) {
      const removedItem = this.droppedItems[index];
      if (removedItem) {
        this.droppedItems.splice(index, 1); // Remove from dropped items
        this.selectedItem = null;
        this.selectedItemIndex = null;
      }

      // Re-enable the item in the sidebar
      const sidebarItem = this.sidebarItems.find(
        (item) => item.name === removedItem.name
      );
      if (sidebarItem) {
        sidebarItem.disabled = false;
      }
    },
    handleItem(item, index) {
      this.selectedItem = item;
      this.selectedItemIndex = index;
    },
    previewCertificate(){
      this.previewLoading = true;
      const currentHTML = this.removeBorderStyle(document.getElementById('certificate').outerHTML)

      // Check if certificate has loaded
      if(this.previewImage === null){
        this.previewLoading = false;
        this.$snotify.error('Certificate not found please wait for certificate to load');
        return;
      }
      
      companyAPI.previewCertificate(currentHTML).then((response) => {
          // Create a URL for the PDF and trigger download
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', 'certificate.pdf');
          document.body.appendChild(link);
          link.click();
          this.previewLoading = false;
          this.$snotify.success('Certificate preview downloaded successfully!')
      }).catch((error) => {
        this.previewLoading = false;
            console.error("Error generating certificate:", error);
        });
    },
    getAllResourceCategories() {
      this.tutorialBtnloading = true;
      this.loading = true;
      userAPI
        .getResourceCategory('Settings')
        .then((resp) => {
          this.resourceId = resp.data.data.id;
          this.tutorialBtnloading = false;
        });
    },
    goToResources(resourceId ) {
      const route = this.$router.resolve({ path: `/resources/${resourceId }` });
      window.open(route.href, '_blank');
    },
  },
};
</script>

<style scoped>
.delete-item-button {
  background-color: #f43d30d6 !important;
  color: #fff !important;
}

.delete-item-button:hover {
  background-color: #f43d30 !important;
  color: #fff !important;
}

#nosupport {
  display: none;
  line-height: 1.5;
}

.dropzone {
  padding: 0 !important;
}

@media (max-width: 1000px) {
  #certificate-container {
    display: none;
  }

  #nosupport {
    display: block;
  }
}
.tutorial-btn.v-btn--disabled{
  opacity: 0.5;
  cursor: no-drop;
  pointer-events: auto;
}
</style>
